import React, { useEffect } from 'react'
import { useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
export default function Complayanananbola({ onUpdateTotal }) {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const { kode_booking, kode_booking2 } = useParams();
    const [dataBookingBola, setDataBookingBola] = useState([]);
    const [show, setShow] = useState(false);
    const [valbola, setValbola] = useState('')
    const [bola, setBola] = useState([]);
    const [selectedLayanan, setSelectedLayanan] = useState([]);

    const formatrupiah = (numb) => {
        const format = numb.toString().split("").reverse().join("");
        const convert = format.match(/\d{1,3}/g);
        const rupiah = "Rp " + convert.join(".").split("").reverse().join("");
        return rupiah;
    };

    const getdata = async () => {
        try {
            const response = await axios.get(urlapi + "Bola");
            setBola(response.data);
        } catch (error) { }
    }

    const handlebola = (e, id, harga) => {
        let allData = JSON.parse(localStorage.getItem('bookingData')) || [];
        if (e.target.checked) {
            // Tambah langsung meskipun idfoto sama sudah ada
            setValbola(id)
            allData.push({
                idbola: id.toString(),
                harga: harga.toString()
            });
        } else {
            // Hapus SATU data yang cocok (hanya satu kali)
            setValbola('')
            const index = allData.findIndex(
                item => item.idbola === id.toString() && item.harga === harga.toString()
            );
            if (index !== -1) {
                allData.splice(index, 1);
            }
        }

        localStorage.setItem('bookingData', JSON.stringify(allData));
        const data = JSON.parse(localStorage.getItem('bookingData')) || [];
        let total = data.reduce((sum, item) => {
            return sum + parseInt(item.harga);
        }, 0);
        localStorage.setItem("totalHarga", total);
        console.log("Total Harga:", total);

        onUpdateTotal();
    }

    const getBookingBola = async () => {
        try {
            const response = await axios.get(urlapi + "BookingBola?kode=" + kode_booking + "&&kode2=" + kode_booking2 + "&&iduser=" + localStorage.getItem('id'));
            setDataBookingBola(response.data)
            console.log(response.data);


        } catch (error) {
            console.log(error.message);
        }
    }

    const handlehapusbola = async (kode_booking, idbola) => {

        Swal.fire({
            title: 'Apakah kamu yakin?',
            text: "Data yang dihapus tidak bisa dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, hapus!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {

                hapusBola(kode_booking, idbola)
            }
        });
    }

    const hapusBola = async (kode, idbola) => {
        await axios.put(urlapi + "Layanan/" + kode + "/" + idbola + "/bola")
            .then((response) => {
                getdata();
                getBookingBola();
                Swal.fire(
                    'Terhapus!',
                    'Data berhasil dihapus.',
                    'success'
                );
            }).catch((err) => {

            });
    }

    useEffect(() => {
        getdata();
        getBookingBola();
    }, [])
    return (
        <div>
            <div className='card mt-1'>
                <div className='card-body'>

                    <div className='d-flex justify-content-between fw-bold mb-2' onClick={() => setShow(!show)}>
                        <small><i className='fas fa-futbol'></i> Bola</small>
                        <small>{valbola != '' ? <i className='fas fa-circle-check text-success'></i> : ''}{' '}<i className={show == false ? 'fas fa-angle-right' : 'fas fa-angle-down'}></i></small>
                    </div>
                    <div className={show == false ? 'd-none' : ''}>
                        {bola.map((data, index) => {
                            return (
                                <div>
                                    <div className='d-flex justify-content-between' key={index}>
                                        <div>
                                            <small style={{ color: "#2b2e5a" }} className='fw-bold'>{data.bola}</small>

                                            <div><span className='badge rounded-pill bg-success'>{formatrupiah(data.harga)}</span></div>
                                        </div>
                                        <div>
                                            <div class={dataBookingBola.id == data.id ? 'form-check d-none' : 'form-check'}>
                                                <img
                                                    src={
                                                        "https://ratumerak.id/adminmmsc/assets/berkas/" +
                                                        data.foto
                                                    }
                                                    className="img-fluid"
                                                    alt="Responsive image"
                                                    style={{ height: "40px" }}
                                                ></img>
                                                <input
                                                    class="form-check-input  border border-danger"
                                                    type="checkbox"
                                                    name="foto"
                                                    onChange={(e) => handlebola(e, data.id, data.harga)}
                                                    id="foto"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    {dataBookingBola.id == data.id ? <div className='text-danger text-center mt-2'><i className='fas fa-warning'></i> Layanan bola ini sudah anda booking <br /> <button className={dataBookingBola.status == '1' ? 'd-none' : 'btn btn-danger btn-sm'} onClick={() => handlehapusbola(kode_booking, data.id)}> <i className='fas fa-trash'></i> Hapus</button></div> : ''}
                                    <hr />
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
